import { AlertDialog, Button, useMediaQuery } from "native-base";
import React from "react";
import { View } from "react-native";

const AlertDlg = ({ children, Validate, registerUser, isSubmitting }) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const onClose = () => setIsOpen(false);
	const cancelRef = React.useRef(null);

	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });

	return (
		<View style={{ flex: 1 }}>
			<Button
				style={isDesktopOrLaptop[0] ? { marginLeft: "auto" } : {}}
				onPress={() => (Validate() ? setIsOpen(!isOpen) : null)}
				// onPress={() => setIsOpen(!isOpen)}
			>
				Sign Up
			</Button>
			<AlertDialog
				top={isDesktopOrLaptop[0] ? 200 : 0}
				size={isDesktopOrLaptop[0] ? "container" : "full"}
				leastDestructiveRef={cancelRef}
				isOpen={isOpen}
				onClose={onClose}
			>
				<AlertDialog.Content
					width={isDesktopOrLaptop[0] ? "container" : "full"}
				>
					{/* <AlertDialog.CloseButton /> */}
					<AlertDialog.Header>Member Registration</AlertDialog.Header>
					<AlertDialog.Body width={isDesktopOrLaptop[0] ? "container" : "full"}>
						{children}
					</AlertDialog.Body>
					<AlertDialog.Footer>
						<Button.Group space={2}>
							<Button
								variant="unstyled"
								colorScheme="coolGray"
								onPress={onClose}
								ref={cancelRef}
							>
								Cancel
							</Button>
							<Button
								isLoading={isSubmitting}
								isLoadingText="Submitting"
								variant={isSubmitting ? "outline" : "solid"}
								onPress={() => registerUser()}
							>
								Confirm Details
							</Button>
						</Button.Group>
					</AlertDialog.Footer>
				</AlertDialog.Content>
			</AlertDialog>
		</View>
	);
};

export default AlertDlg;
